import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.irScenes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.irScenes.actionsLoading;
export const getItems = (state:RootState) => state.irScenes.items;
export const getItemsSelect = (state:RootState) => state.irScenes.dropDownItems;
export const getItemsCount = (state:RootState) => state.irScenes.itemsCount;
export const getItemForEdit = (state:RootState) => state.irScenes.itemForEdit;
export const getError = (state:RootState) => state.irScenes.error;
export const getErrorAction = (state:RootState) => state.irScenes.errorAction
export const validationErrors = (state: RootState) => state.irScenes.validationErrors;
